import { createActionAndMutation } from "../utils";
const dataMessage = {
        isSend: false,
        id: null};
const nbmessage = 0;
const setSended = (state, data) => {
    state.dataMessage.isSend=data;
}
const setNbMessage = (state, data) => {
    state.nbmessage=data;
}
const { mutations, actions } = createActionAndMutation({
    setSended,
    setNbMessage
})
const getters = {
    isSend: (state) => {
        return state.dataMessage.isSend;
    },
    nbMessageNotLu: (state) => {
        return state.nbmessage;
    }
}
export default {
    state: {
        dataMessage,
        nbmessage
    },
    mutations,
    actions,
    getters,
};